import { render, staticRenderFns } from "./ProductEntryWidget.vue?vue&type=template&id=57314fca&"
import script from "./ProductEntryWidget.vue?vue&type=script&lang=ts&"
export * from "./ProductEntryWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports